<app-form-input
[parentForm]="parentForm"
[value]="valeurEstimee?.valeur"
[disabled]="disabled"
[label]="step3.valeur"
[type]="'number'" [rule]="'digits_2'"
[name]="getUid()+'_SepAtt_valeur'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[value]="valeurEstimee.devise"
[disabled]="disabled"
[label]="step3.devise"
[type]="'autocomplete'" [rule]="'required|pattern_13'"
[errorMessage]="{'pattern' : 'ctr_pattern_13'}"
[autoCompleteType]="'DEVISE'"
[autoCompleteTypeIndex]="0"
[name]="getUid()+'_SepAtt_devise'">
</app-form-input>

<app-fourchette  [uid]="getUid()" [parentForm]="parentForm" [fourchette]="valeurEstimee?.fourchette" [disabled]="disabled"></app-fourchette>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg1" [id]="getStepId() + rg1"></app-form-input-error>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg2" [id]="getStepId() + rg2"></app-form-input-error>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg3" [id]="getStepId() + rg3"></app-form-input-error>
<!---->



<!---->

